<template>
  <v-card max-width="1000" class="pa-0 mx-auto" :loading="loading">
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>{{ $t("info.system") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <h2 class="text-center pt-2">
      {{ $t("info.admityear") }} : {{ admitSemester }} / {{ admitYear }}
    </h2>
    <div class="text-center pt-1">
      <v-chip color="#ddd" variant="flat" class="py-1 px-7"
        ><h3>
          {{ $t("info.graduate") }}
        </h3></v-chip
      >
    </div>
    <h1 class="text-center pt-1 mb-3">
      {{ $t("info.maininfo") }}
    </h1>
    <div class="custom-card">
      <v-card>
        <v-card-text class="mx-0 mx-md-2 mb-2 px-0 px-md-2 px-xl-4">
          <h3 class="text-center pb-2">
            <v-icon class="pb-1">mdi-information-slab-box</v-icon>
            {{ $t("info.info") }}
          </h3>
          <a
            target="_blank"
            :href="
              $root.$i18n.locale === 'en'
                ? 'https://reg.kmitl.ac.th/storage/kmitl1/info/graduate/graduate_en.png'
                : 'https://reg.kmitl.ac.th/storage/kmitl1/info/graduate/graduate_th.png'
            "
          >
            <v-img
              :src="
                $root.$i18n.locale === 'en'
                  ? 'https://reg.kmitl.ac.th/storage/kmitl1/info/graduate/graduate_en.png'
                  : 'https://reg.kmitl.ac.th/storage/kmitl1/info/graduate/graduate_th.png'
              "
              style="border: 1px solid #ddd; border-radius: 8px"
              max-height="750px"
            >
            </v-img>
          </a>
          <div class="text-center">
            <v-chip
              class="bordered-pn mt-2 mx-auto py-0 py-sm-1"
              color="success"
              ><h5>
                {{ $t("info.open") }}
              </h5>
            </v-chip>
            <br />
            <v-chip class="bordered-pn mt-2 mx-auto py-0 py-sm-1" color="error"
              ><h5>
                {{ $t("info.close") }}
              </h5>
            </v-chip>
          </div>
        </v-card-text>
        <v-card-text class="mx-0 mx-md-2 mb-2 px-0 px-md-2 px-xl-4"
          ><h3 align="center" justify="center" class="pa-0">
            <v-icon>mdi-text-box-multiple</v-icon>
            {{ $t("info.documentform") }}
          </h3>
          <h4 class="text-center mt-2">
            {{ $t("info.select") }}
          </h4>
          <v-table class="my-1 my-md-2 bordered-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 60%">
                  <h4>{{ $t("info.document") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_th") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_en") }}</h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t("info.form1") }}</td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info1_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info1_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("info.form2") }}
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info2_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info2_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>{{ $t("info.form3") }}</td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/educalendar/2569/th-2.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="info"
                      icon="mdi-link-box-variant"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/educalendar/2569/en-2.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="info"
                      icon="mdi-link-box-variant"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("info.form4") }}
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info4_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/info/graduate/info4_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
            </tbody>
          </v-table>
          <v-table class="pb-2 bordered-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 60%">
                  <h4>{{ $t("info.form") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_th") }}</h4>
                </th>
                <th class="text-center">
                  <h4>{{ $t("info.version_en") }}</h4>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t("info.doc1") }}</td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form1_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form1_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("info.doc2") }}
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form2_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form2_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>{{ $t("info.doc3") }}</td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form3_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form3_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
              <tr>
                <td>
                  {{ $t("info.doc4") }}
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form4_th.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
                <td class="text-center">
                  <a
                    href="https://www.reg.kmitl.ac.th/storage/kmitl1/form/graduate/form4_en.pdf"
                    target="_blank"
                  >
                    <v-icon
                      color="error"
                      icon="mdi-file-download"
                      size="x-large"
                    ></v-icon
                  ></a>
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import PublicProvider from "@/services/public.provider.js";
const publicProvider = new PublicProvider();
// @ is an alias to /src

export default {
  name: "InfoView",

  data: () => ({
    loading: false,
    tabs: 2,
    levelId: "2",
    yearId: 0,
    admitYear: null,
    admitSemester: null,
  }),

  methods: {
    async fetch_data(levelInput) {
      this.loading = true;

      if (!levelInput) {
        levelInput = 2;
      }
      const data1 = await publicProvider
        .getCurrentYear(levelInput)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (data1) {
        this.yearId = data1.YEAR_ID;
        this.admitYear = data1.ADMIT_YEAR;
        this.admitSemester = data1.ADMIT_SEMESTER;
      }

      this.loading = false;
    },
    fetch_data_from_url() {
      const tab = parseInt(this.$route.query.tab);
      this.fetch_data(tab);
    },
  },

  watch: {
    "$route.query.tab"(newValue = 2) {
      this.tabs = parseInt(newValue);
      this.levelId = newValue;
      this.fetch_data(this.levelId);
    },
  },

  created() {
    const tab = parseInt(this.$route.query.tab);
    this.tabs = tab;
    this.fetch_data_from_url();
  },
};
</script>

<style scoped>
.shadow-text {
  text-shadow: 0px 0px 3px #919191;
}
.custom-card .v-card-text {
  border: 1px solid #dadada;
  border-radius: 0px;
}
.custom-text {
  color: wheat;
}

.bordered-table {
  border: 1px solid #ddd; /* Customize border style, color, etc. */
  border-radius: 8px;
}

.bordered-pn {
  border: 1px dashed;
}

.v-chip {
  height: auto !important;
  white-space: normal;
}
</style>
